<template>
  <transition name="zoom" mode="out-in">
    <div v-if="$store.state.videoVisible" class="lightbox">
      <div class="close-button" @click="$store.state.videoVisible = false">
        x
      </div>
      <iframe
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
        width="100%"
        height="100%"
        type="text/html"
        :src="url"
      ></iframe>
    </div>
  </transition>
</template>
<script>
export default {
  props: {
    url: {},
  },
};
</script>
 No newline at end of file
